import { useState } from 'react';
import { Box, Button } from "@mui/material";

const ArtistName = ({ setActiveTab, draft, setDraft }) => {
  const [artistNameEn, setArtistNameEn] = useState(draft?.artistNameEn || '');
  const [artistNameFa, setArtistNameFa] = useState(draft?.artistNameFa || '');

  const handleSubmit = () => {
    const enName = artistNameEn.trim();
    const faName = artistNameFa.trim();
    
    const newDraft = {
      ...draft,
      artistNameEn: enName,
      artistNameFa: faName,
    }
    setDraft(newDraft);
    setActiveTab('selectMoj');
  };

  return (
    <>
      <Box
        style={{
          width: "100%",
          height: "78%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <div
          className="custom-input-container"
          style={{ height: "30%", width: "100%", marginTop: "10%" }}
        >
          <label className="custom-input-label">Artist name Eng</label>
          <input
            type="text"
            placeholder="Benyamin"
            className="custom-input"
            style={{ height: "100%" }}
            value={artistNameEn}
            onChange={(e)=>setArtistNameEn(e.target.value)}
          />
        </div>
        <div
          className="custom-input-container"
          style={{ height: "30%", width: "100%", marginBottom: "10%" }}
        >
          <label className="custom-input-label">Artist name Fa</label>
          <input
            type="text"
            placeholder="بنیامین"
            className="custom-input"
            value={artistNameFa}
            onChange={(e)=>setArtistNameFa(e.target.value)}
            style={{
              height: "100%",
              direction: "rtl",
              fontFamily: "Dastnevis",
            }}
          />
        </div>
      </Box>
      <Button
        className="button-save"
        onClick={handleSubmit}
      >
        Next
      </Button>
    </>
  );
};

export default ArtistName;
